export const initializeSocialShare = () => {
  const components = document.querySelectorAll('[data-component="social-share"]')

  components.forEach(component => {
    const button = component.querySelector('[data-action="instagram"]')
    if (!button) return

    const label = button.querySelector('[data-label]')
    const defaultLabel = label ? label.textContent : ''
    const copiedLabel = component.dataset.copiedLabel || defaultLabel
    const url = component.dataset.shareUrl
    const title = component.dataset.shareTitle

    button.addEventListener('click', async () => {
      if (navigator.share) {
        try {
          await navigator.share({ title, url })
          return
        } catch (error) {
          if (error?.name === 'AbortError') return
        }
      }

      try {
        await navigator.clipboard.writeText(url)
        if (label) {
          label.textContent = copiedLabel
          setTimeout(() => {
            label.textContent = defaultLabel
          }, 2000)
        }
      } catch (error) {
        // Clipboard API unavailable — nothing more we can do here.
      }
    })
  })
}
